import type { InputHTMLAttributes } from 'react'
import { CheckIcon } from './icons'
import { Text } from './typography'

interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const BOX_BASE = [
  'relative flex shrink-0 mr-3 items-center justify-center size-6 rounded-sm border transition',
  'group-has-checked:border-0',
].join(' ')

const BOX_ACTIVE = [
  'bg-white border-neutral-100',
  'group-has-checked:bg-indigo-base',
  'group-hover:border-indigo-100 group-hover:shadow-radio-hover',
  'group-has-focus:border-0 group-has-focus:ring-2 group-has-focus:ring-indigo-base',
].join(' ')

const BOX_DISABLED = [
  'bg-neutral-50 border-neutral-300',
  'group-has-checked:bg-indigo-100',
].join(' ')

export function CheckboxInput({
  label,
  disabled,
  checked,
  className = '',
  ...props
}: CheckboxInputProps) {
  if (!label) {
    const isFilled = checked || disabled
    return (
      <span
        className={[
          'flex size-6 shrink-0 items-center justify-center rounded-sm transition',
          isFilled
            ? disabled
              ? 'bg-indigo-100'
              : 'bg-indigo-base'
            : 'border border-neutral-100 bg-white',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {isFilled && <CheckIcon className="size-4 text-white" />}
      </span>
    )
  }

  return (
    <label
      className={`group flex items-center justify-start gap-0 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        className="peer size-0"
        {...props}
      />
      <span
        className={`${BOX_BASE} ${disabled ? BOX_DISABLED : BOX_ACTIVE} ${className}`}
      >
        <CheckIcon className="hidden size-4 text-white group-has-checked:block" />
      </span>
      <Text className={`${disabled ? 'text-neutral-300' : 'text-neutral-900'}`}>
        {label}
      </Text>
    </label>
  )
}
